"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiscUtils = void 0;
var js_utils_1 = require("./js-utils");
/**
 * @author arnozhang
 * @date 2019/06/25
 */
var TAG = 'MiscUtils';
var MiscUtils = /** @class */ (function () {
    function MiscUtils() {
    }
    MiscUtils.currentTimeMillis = function () {
        return new Date().getTime();
    };
    MiscUtils.formatBytes = function (bytes, decimals) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        var k = 1024;
        var dm = decimals || 2;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };
    MiscUtils.formatPercentage = function (value) {
        return MiscUtils.format2DecimalPlaces(value) + "%";
    };
    MiscUtils.format2DecimalPlaces = function (value) {
        value = js_utils_1.JsUtils.parseFloatSafe(value);
        return Math.round(value * 100) / 100;
    };
    MiscUtils.parseQueryString = function (queryString) {
        var map = {};
        if (js_utils_1.JsUtils.isEmpty(queryString)) {
            return map;
        }
        queryString = queryString[0] === '?' ? queryString.substr(1) : queryString;
        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            map[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return map;
    };
    MiscUtils.openInNewTab = function (url) {
        var win = window.open(url, '_blank');
        win.focus();
    };
    return MiscUtils;
}());
exports.MiscUtils = MiscUtils;
